module.exports = __webpack_public_path__ + "static/media/logo.d40fa562.svg";